export default {
  isLoading: false,
  documents: {},
  getidConfig: {},
};
